import { AnalyticsStore } from 'bernie-core';

let gssDialog;

export const openAuthWindow = (url, width, height) => {
  const left = window.top.outerWidth / 2 + window.top.screenX - width / 2;
  const top = window.top.outerHeight / 2 + window.top.screenY - height / 2;

  return window.open(
    decodeURIComponent(url),
    'GSSAuthWindow',
    `copyhistory=no,toolbar=no,menubar=no,location=no,status=no,directories=no,
    width=${width},height=${height},top=${top},left=${left}`
  );
};

export const handleSignInSignUpClick = (event, analytics: AnalyticsStore, eventMetadata: string): void => {
  event.preventDefault();
  if (gssDialog && gssDialog.closed === false) {
    gssDialog.focus();
  } else {
    window.userAuthenticated = undefined;
    gssDialog = openAuthWindow(event.target.href, 400, 520);
    if (gssDialog) {
      gssDialog.focus();
      analytics.trackEvent('GSS.Dialog.Window.Open', 'GSS dialog window opened', analytics.omnitureData, null, true);
      const timer = setInterval(() => {
        if (gssDialog.closed) {
          clearInterval(timer);
          if (getGSSDialogAuthResponse()) {
            refreshUserSession();
          } else {
            analytics.trackEvent('GSS.window.popup.cancelled', 'GSS dialog window cancelled', analytics.omnitureData, null, true);
          }
        }
      }, 100);
    } else {
      analytics.trackEvent('GSS.window.popup.blocked', 'Browser window popup blocked', analytics.omnitureData, null, true);
      window.location.assign(event.target.href);
    }
  }
};

export const getGSSDialogAuthResponse = () => {
  let isUserAuthenticated;
  if (typeof Storage !== 'undefined') {
    isUserAuthenticated = localStorage.getItem('userAuthenticated');
    localStorage.removeItem('userAuthenticated');
  } else {
    isUserAuthenticated = window.userAuthenticated;
  }
  try {
    return JSON.parse(isUserAuthenticated);
  } catch (e) {
    return null;
  }
};

export const refreshUserSession = () => {
  window.location.reload();
};
